import React from 'react';
import { Image } from '@unpic/react';
import { IProductGalleryImage } from '../../../types/product/productDetailPage';
import DefaultVideoImage from './DefaultVideo';

interface VideoThumbnailImageProps {
  image?: IProductGalleryImage;
  video?: string;
  position: number;
}

const VideoThumbnailImage = ({ image, video, position }: VideoThumbnailImageProps) => {
  if (!image) return <DefaultVideoImage video={video} />;
  return (
    <Image
      key={image.id}
      className="pd-cover-parent"
      layout="constrained"
      src={image.url}
      aspectRatio={1}
      alt={image.title}
      priority={position < 4}
      breakpoints={[48, 92]}
      width={78}
      cdn="contentful"
    />
  );
};

export default VideoThumbnailImage;
